<template>
    <v-container>
        <v-row dense>
            <v-row>
                <v-col cols="11">
                    <v-card-title class="titulopagina">
                        REPORTE DE PRODUCCIONES
                    </v-card-title>
                </v-col>
                <v-col cols="1">
                    <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas"><v-icon color="blue" large>help</v-icon></v-alert>
                </v-col>
            </v-row>
            <modal-ayuda></modal-ayuda>
            <v-col cols="12">
                <v-card color="#C0D5ED">
                    <v-card-actions>
                        <v-col cols="3">
                            <v-select
                                v-model="anio"
                                label="Seleccione año para reporte"
                                filled
                                outlined
                                hide-details
                                @change="cargarProduccion"
                                :items="anios()"
                            ></v-select>
                        </v-col>
                        <v-col cols="3">
                            <v-select
                                v-model="mes"
                                :items="meses"
                                item-text="mes"
                                item-value="id"
                                @change="cargarProduccion"
                                label="Seleccione mes para reporte"
                                filled
                                outlined
                                hide-details
                            ></v-select>
                        </v-col>
                        <v-col>
                            <v-btn @click="cargarProduccion" color="blue" dark>
                                RECARGAR
                            </v-btn>
                        </v-col>
                        <v-col>
                            <!-- <v-btn small dark color="#F1894C" @click="abrir_modal_registro_prod()">Registrar Producciones </v-btn> -->
                        </v-col>
                        <v-col>
                            <v-btn class="ml-2" @click="download" color="green darken 1" dark>Excel</v-btn>
                        </v-col>
                        <!-- <v-col>
                            <date-picker v-model="fecha" placeholder ="Seleccione Fecha"  @change="cargarProduccionDiaria()" format="DD-MM-YYYY" :default-value="fecha" valueType="YYYY-MM-DD" class="float-right mr-1"></date-picker>
                        </v-col> -->
                    </v-card-actions>
                </v-card>
            </v-col>

            <!-- RESUMEN PLANTA HARINA -->
            <v-col cols="12" class="mb-4">
                <v-card color="#C0D5ED" dark>
                    <v-tabs
                        fixed-tabs
                        background-color="cyan darken-3"
                        dark
                        v-model="tabs"
                        height="min-content"
                    >
                    <v-tabs-slider color="yellow"></v-tabs-slider>
                        <v-tab key="tab_planta_harina">
                            <v-card-title>
                                Producción Planta Harina
                            </v-card-title>
                        </v-tab>
                        <v-tab key="tab_planta_hidrolizado">
                            <v-card-title>
                                Producción Planta Hidrolizado
                            </v-card-title>
                        </v-tab>
                        <v-tab key="tab_combustible_energia">
                            <v-card-title>
                                Combustible FON6 / EE y Generación Eléctrica
                            </v-card-title>
                        </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tabs">
                        <!-- RESUMEN PLANTA HARINA -->
                        <v-tab-item  key="tab_planta_harina">
                            <v-row class="py-2">
                                <v-col>
                                    <v-card>
                                        <v-simple-table dense>
                                            <thead>
                                                <tr>
                                                    <th>Día</th>
                                                    <th v-for="header in headers_planta_harina" class="th text-center">{{ header }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="fila in resumen_planta_harina" class="tr">
                                                    <template>
                                                        <td class="td--dia">{{ fila.dia }}</td>
                                                    </template>
                                                    <template>
                                                        <td class="td" v-for="(header, dato) in headers_planta_harina">
                                                            <template v-if="dato.includes('Proteina')">
                                                                {{ fila[dato] | formatear_porcentaje }}
                                                            </template>
                                                            <template v-else-if="fila[dato] % 1 == 0">
                                                                {{ fila[dato] | formatear_miles }}
                                                            </template>
                                                            <template v-else>
                                                                {{ fila[dato] }}
                                                            </template>
                                                        </td>
                                                    </template>
                                                </tr>
                                            </tbody>
                                        </v-simple-table>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-tab-item>

                        <!-- RESUMEN PLANTA HIDROLIZADO -->
                        <v-tab-item  key="tab_planta_hidrolizado">
                            <v-row class="py-2">
                                <v-col>
                                    <v-card>
                                        <v-simple-table dense>
                                            <thead>
                                                <tr>
                                                    <th>Día</th>
                                                    <th v-for="header in headers_planta_hidrolizado" class="th text-center">{{ header }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="fila in resumen_planta_hidrolizado" class="tr">
                                                    <template>
                                                        <td class="td--dia">{{ fila.dia }}</td>
                                                    </template>
                                                    <template>
                                                        <td class="td" v-for="(header, dato) in headers_planta_hidrolizado">
                                                            <template v-if="fila[dato] % 1 == 0">
                                                                {{ fila[dato] | formatear_miles }}
                                                            </template>
                                                            <template v-else>
                                                                {{ fila[dato] }}
                                                            </template>
                                                        </td>
                                                    </template>
                                                </tr>
                                            </tbody>
                                        </v-simple-table>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-tab-item>

                        <!-- RESUMEN COMBUSTIBLE / EE Y ENERÍA-->
                        <v-tab-item  key="tab_combustible_energia">
                            <v-row class="py-2">
                                <v-col>
                                    <v-card>
                                        <v-simple-table dense>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th colspan="4" class="text-center">Combustible FO N6</th>
                                                    <th colspan="4" class="text-center">EE y Generación Eléctrica</th>
                                                </tr>
                                                <tr>
                                                    <th>Día</th>
                                                    <th v-for="header in headers_combustible" class="th text-center">{{ header }}</th>
                                                    <th v-for="header in headers_energia" class="th text-center">{{ header }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(fila, idx) in resumen_combustible" class="tr">
                                                    <template>
                                                        <td class="td--dia">{{ fila.dia }}</td>
                                                    </template>
                                                    <template>
                                                        <td class="td" v-for="(header, dato) in headers_combustible">
                                                            <template v-if="fila[dato] % 1 == 0">
                                                                {{ fila[dato] | formatear_miles }}
                                                            </template>
                                                            <template v-else>
                                                                {{ fila[dato] }}
                                                            </template>
                                                        </td>
                                                    </template>
                                                    <template>
                                                        <td class="td" v-for="(header, dato) in headers_energia">
                                                            <template v-if="resumen_energia[idx][dato] % 1 == 0">
                                                                {{ resumen_energia[idx][dato] | formatear_miles }}
                                                            </template>
                                                            <template v-else>
                                                                {{ resumen_energia[idx][dato] }}
                                                            </template>
                                                        </td>
                                                    </template>
                                                </tr>
                                            </tbody>
                                        </v-simple-table>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card>
            </v-col>


        <!-- produccion-harina-dia  -->
        <produccion-harina-dia></produccion-harina-dia>
        </v-row>
    </v-container>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import ProduccionHarinaDia from '@/components/shared/Produccion_Harina_Dia.vue';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';

export default {
    data:()=>({
        fecha:'',
        recepciones:[],
        items:[],
        lineas:[],
        cambio_linea:{id:null, nombre:""},
        abrir_modal:false,
        mostrar_recepciones:false,
        mp_procesada:[],
        tipo_mps:[],
        produccion_diaria:null,
        detalles_produccion_dia:[],
        recepcion_lineas:[],
        calidad_linea_total:[],
        total_distr_patio: 0,
        total_mmpp:0,
        detalle_lineas:[],
        primero:null,
        ultimo:null,
        url_excel: '',
        anio: new Date().getFullYear(),
        mes: new Date().getMonth() + 1,
        meses: [
            {mes: 'Enero', id: 1},
            {mes: 'Febrero', id: 2},
            {mes: 'Marzo', id: 3},
            {mes: 'Abril', id: 4},
            {mes: 'Mayo', id: 5},
            {mes: 'Junio', id: 6},
            {mes: 'Julio', id: 7},
            {mes: 'Agosto', id: 8},
            {mes: 'Septiembre', id: 9},
            {mes: 'Octubre', id: 10},
            {mes: 'Noviembre', id: 11},
            {mes: 'Diciembre', id: 12},
        ],
        headers_planta_harina: {
            "Recepcion": "Recepción", "Procesado": "Procesado", 
            "Saldo": "Saldo en Pozos", "Coho": "% Coho", "Drenado": "% Drenado", 
            "ProduccionH": "Producción Harina", "RendimientoH": "% Rendimiento", "Proteina68": "Proteína >68%", 
            "Proteina67": "Proteína 66-68%", "Proteina66": "Proteína <66%", "DespachoH": "Despachos Harina", 
            "ProduccionA":"Producción Aceite", "RendimientoA": "% Rendimiento", "AcidezA": "% Acidez", 
            "DespachoA": "Despachos Aceite", "HOHarina": "Horas Operativas"
        },
        resumen_planta_harina: [],
        headers_planta_hidrolizado: {
            "Recepcion": "Recepción", "Procesado": "Procesado", 
            "Saldo": "Saldo en TKs", "ProduccionA": "Producción Aceite",
            "RendimientoA": "% Rendimiento", "AcidezA": "% Acidez", 
            "DespachoA": "Despachos", "ProduccionC": "Producción Concentrado",
            "RendimientoC": "% Rendimiento", "DespachoC": "Despachos Concentrado",
            "DespachoF": "Despachos Fertilizante", "HOHidrolizado": "Horas Operativas"
        },
        resumen_planta_hidrolizado: [],
        headers_combustible: {
            "RCombustible": "Recepción", "CCombustible": "Consumo", 
            "StockCombustible": "Stock", "ConsumoE": "Consumo Específico"
        },
        resumen_combustible: [],
        headers_energia: {
            "EnergiaSaesa": "Saesa Kw/hr", "EnergiaGSaesa": "Generador Saesa Kw/hr", 
            "EnergiaGCumming": "Generador Cumming Kw/hr", "ConsumoE": "Consumo Específico"
        },
        resumen_energia: [],
        tabs: null,
    }),
    filters: {
        formatear_porcentaje(value) {
            if(!value) return `0%`;
            
            if(typeof value === 'string') {
                if(value.includes(',')) value = value.replace(',', '.');
                value = Number.parseFloat(value);
            }
        
            if(value % 1 === 0)
                return `${value}%`;

            return `${value.toFixed(2)}%`;
        },
    },
    mounted(){
        this.fecha = this.moment().format('YYYY-MM-DD');
        this.cargarProduccionDiaria();
        this.cargarProduccion();
    },
    methods: {
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Reporte de Producciones`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se muestra un resumen de las producciones diarias de cada planta y de la recepción y consumo de combustibles/energía. Se puede seleccionar el año y mes para obtener un reporte, utilizar el botón "Recargar" ( insert_img_help-produccion-diaria_ic2.png?width=100px ) para volver a obtener la información, registrar las producciones diarias o exportar los reportes a un Excel.`},
                {   tipo:`label`,   texto:`- Los reportes se muestran en distintos tabs: "Producción Planta Harina", "Producción Planta Hidrolizado", "Combustible FON6 / EE y Generación Eléctrica"`},
                {   tipo:`label`,   texto:`- El botón "Registrar Producciones" ( insert_img_help-produccion-diaria_ic1.png ) abre una ventana que sirve para registrar la producción diaria de la planta de harina, indicando la materia prima utilizada, la cantidad de harina y aceite producida y los estanques de aceite utilizados para esa producción (se puede agregar o eliminar producción de distintos estanques con el botón +), además de indicar opcionalmente el folio de producción.`},
                {   tipo:`imgtexto`,  url:`help-produccion-diaria.png`, ratio:'4.1', cols:'2', texto:`- En la misma ventana, en la tabla de abajo, se muestra una lista de toda la materia prima producida para ese día, en donde también se puede cambiar de lína o de proceso de cada guía de la producción (en caso de que la trazabilidad esté habilitada)`},
            ];
            
            Event.$emit('mostrar_alert', jiji);
        },
        async cargarProduccion() {
            // await this.cargarRecepciones();
            this.mostrarLoading({titulo:'Cargando Producción...',color:'green'})

            const data = { 
                anio: this.anio, 
                excel: false,
                mes: this.mes, 
            }
            const url = `${this.base_url}produccion_diaria/produccion_anual`;
            await this.axios.post(url, data, this.headers).then(res => {
                console.log(res);
                /* const promedios_harina = ['Coho', 'Drenado', 'RendimientoH', 'RendimientoA', 'AcidezA']; */
                this.resumen_planta_harina = this.rellenarDatos(res.data.data.my_collect);
                this.resumen_planta_hidrolizado = this.rellenarDatos(res.data.data.my_collect2);
                this.resumen_combustible = this.rellenarDatos(res.data.data.my_collect3);
                this.resumen_energia = this.rellenarDatos(res.data.data.my_collect4);

                this.ocultarLoading();
            }).catch(e => {
                this.ocultarLoading();
                this.errorMessage(e, "Error al cargar produccion diaria ");
            });
        },

        rellenarDatos(coleccion, promedios = []) {
            /* const sumas = {
                dia: 'Totales'
            };
            coleccion.forEach((val, i) => {
                Object.entries(val).forEach(([item, value]) => {
                    if(!['dia', 'mes'].includes(item)) {
                        if(!value) value = 0;
                        if(!value % 1 == 0) coleccion[i][item] = value.toString().replace(".", ",");;
                        if(!sumas[item]) sumas[item] = 0;
                        
                        sumas[item]= sumas[item] + parseFloat(value);
                    }
                });
            });

            promedios.forEach(prom => {
                sumas[prom] = sumas[prom] / coleccion.length;
            });

            coleccion.push(sumas); */
            return coleccion;
        },
        async cargarRecepciones(){
            this.mostrarLoading({titulo:'Cargando Recepción Materia Prima...',color:'green'})

            let url = `${this.base_url}mp_procesada/recepciones/${this.fecha}`;
            await this.axios.get(url,this.headers).then((res)=>{
                console.log('recepciones:',res.data);
                this.recepciones = res.data;
                this.ocultarLoading();
            }).catch((e)=>{
                this.ocultarLoading();
                this.errorMessage(e, "Error al cargar recepciones ");
            });
        },

        rellenarRegistros(){
            this.recepcion_lineas = [];
            let distrib = 0;
            let dist = [];
            this.recepciones.forEach(async r => {
                dist = [];
                distrib = 0;
                if (r.distrib_patio.length > 0){
                    r.distrib_patio.forEach(d => {
                        distrib += d.kilos;
                        dist.push({'linea':d.linea, 'pozo':d.pozo, 'kilos':d.kilos, 'asignar':0})
                    });
                } else {
                    dist.push({'linea':null, 'pozo':null, 'kilos':r.distribuir, 'asignar':0})
                }
                
                this.recepcion_lineas.push({
                    'guias_id': r.guias_id,
                    'fecha_recepcion':r.fecha,
                    'materia_prima': r.materia_prima,
                    'mps_id': r.mps_id,                    
                    'ticket': r.ticket,
                    'guia': r.guia,
                    'peso': r.peso,
                    'asignado': r.asignado,
                    'por_asignar': r.por_asignar,
                    'distrib_patio': dist,
                    'distribuido_patio': distrib,
                    'procesado': r.parcial,
                    'restriccion': r.restriccion,
                    'lineas':r.linea,
                    'seleccionada':r.seleccionada,
                    'color':null
                });
            });

            //console.log('registrosrellenados',this.recepcion_lineas);
        },

        async guardarMpProcesada(it,id,idx,index){
            //console.log('item',it,'linea_id',id);
            let kilos = this.items[index].mps[idx].kilos;
            if((kilos != null) && (kilos != '')){
                let body = {
                        produccion_diaria_id:it.pdd_id,
                        tipo_mps_id:it.id,
                        fecha:this.fecha,
                        lineas_id:id,
                        kilos:kilos,
                    }
                
                //console.log('body produccion',body);
                let url = `${this.base_url}detalle_produccion_dia`;
                await this.axios.post(url,body,this.headers).then((res)=>{
                    //console.log('realizado',res.data);
                }).catch((e)=>{
                    this.errorMessage(e, "Error al guardar mmpp procesada ");
                });
            }
        },

        async guardarDetalleProduccionDia(detalle_produccion_dia,index){
            let url = `${this.base_url}detalle_produccion_dia`;
            let body = {};
            body = {
                    mp_procesada_aprox:detalle_produccion_dia.mp_procesada_aprox,
                    mp_procesada_con_restriccion:detalle_produccion_dia.mp_procesada_con_restriccion,
                    pt_produccion_aprox:detalle_produccion_dia.pt_produccion_aprox,
                    lineas_id:detalle_produccion_dia.lineas_id,
                    produccion_diaria_id:this.produccion_diaria.id
            }
            if(detalle_produccion_dia.id == null){
                /**crear */
                await this.axios.post(url,body,this.headers).then((res)=>{
                    this.lineas[index].detalle_produccion_dia.id = res.data.data.id;
                    //this.$set(this.lineas[index].detalles_produccion_dia, 'id', res.data.data.id);
                }).catch((e)=>{
                    this.errorMessage(e, "Error al guardar detalle produccion ");
                });
            }else{
                /**actualizar */
                url = `${this.base_url}detalle_produccion_dia/${detalle_produccion_dia.id}`;
                await this.axios.put(url,body,this.headers).then((res)=>{
                    //console.log('detalle_actualizado',res.data.data)
                }).catch((e)=>{
                    this.errorMessage(e, "Error al guardar detalle produccion ");
                });

            }
            //console.log('detalle_actualizado',this.lineas[index],index);
        },
        /**recibe la recepcion, index de array y linea a crear o actualizar mp procesada */
        async guardarMpGuia(item,index,linea_id){
            //console.log('item',item,'linea_id',linea_id,'index',index);

            let id = this.recepcion_lineas[index].lineas[linea_id].id;
            let kilos = this.recepcion_lineas[index].lineas[linea_id].kilos;
            if(kilos != null){
                let body = {
                    identificador_romana_id:item.guias_id,
                    produccion_diaria_id:this.produccion_diaria.id,
                    lineas_id:linea_id,
                    kilos: kilos
                }
                let url = `${this.base_url}mp_procesada`;
                if(id==null){
                    /**crear */
                    await this.axios.post(url,body,this.headers).then((res)=>{
                        //console.log('mp_procesada creada',res.data);
                        this.actualizar_recepcion_linea(item,index,linea_id,res.data);
                    }).catch((e)=>{
                        //console.log('error',e)
                    });
                }else{
                    /**actualizar */
                    url = `${this.base_url}mp_procesada/${id}`;
                    await this.axios.put(url,body,this.headers).then((res)=>{
                        //console.log('mp_procesada actualizada',res.data);
                        this.actualizar_recepcion_linea(item,index,linea_id,res.data);
                    }).catch((e)=>{
                        //console.log('error',e)
                    });
                }
            }
            
            
            /*console.log('body',body);
            let val = item;
            val.lineas[linea_id].id = 1;
            console.log('val',val);
            this.$set(this.recepcion_lineas, index, val);
            console.log('id creado',this.recepcion_lineas);*/
        },

        actualizar_recepcion_linea(item,index,linea_id,data){
            let val = item;
            val.lineas[linea_id].id = data.mp_procesada.id;
            val.asignado = data.ticket_guia.asignado;
            val.por_asignar = data.ticket_guia.por_asignar;
            this.$set(this.recepcion_lineas, index, val);
        },

        abrir_modal_registro_prod(){
            Event.$emit('abrir_modal_produccion_harina_dia', this.detalle_lineas, this.fecha);
        },

        async cargarProduccionDiaria(){
            // await this.cargarRecepciones();
            this.mostrarLoading({titulo:'Cargando Producción...',color:'green'})

            let url = `${this.base_url}produccion_diaria/${this.fecha}`;
            await this.axios.get(url,this.headers).then((res)=>{
                this.detalle_lineas = res.data.detalle_lineas;
                this.rellenarRegistros();
                this.ocultarLoading();
            }).catch((e)=>{
                this.ocultarLoading();
                this.errorMessage(e, "Error al cargar produccion diaria ");
            });
        },

        async download(){
            this.mostrarLoading({titulo:'Generando Excel...',color:'green'})
            const url = `${this.base_url}produccion_diaria/produccion_anual`;
            const data = {
                fecha: this.fecha,
                mes: this.mes,
                excel: true,                    
            }
            console.log(data);
            await this.axios.post(url, data, this.headers).then((response)=>{
                this.url_excel = response.data.url_excel;
                this.ocultarLoading();
                window.location.href = this.download_url.replace('bitacoras', 'plantillas') + this.url_excel;

            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },
        anios() {
            const anioActual = parseInt(this.moment().format('YYYY'));
            //const anioActual = 2027;
            const anios = [];
            
            for(let i = anioActual; i >= 2023; i--) {
                anios.unshift(i);
            }
            
            return anios;
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url', 'headers', 'download_url']),
    },
    components:{
        DatePicker,
        'produccion-harina-dia': ProduccionHarinaDia,
        'modal-ayuda': ModalAyudas,
    }
}
</script>
<style scoped>
    .td {
        border-right: thin solid rgba(0, 0, 0, 0.12);
        text-align: right;
    }
    .tr {
        background-color: #6D8DB7;
        color: #000;
    }
    .tr:hover {
        background-color: #5B78A7 !important;
    }
    .th {
        border-right: thin solid rgba(0, 0, 0, 0.12);
        background-color: #243674 !important;
        color: #fff !important;
        font-size: 0.9em !important;
    }
    .td--dia {
        border-right: thin solid rgba(0, 0, 0, 0.12);
        background-color: #496296 !important;
        color: #fff !important;
    }
    .title {
        background-color:#6D8DB7;color:#fff !important; padding:0.3em 0.5em; border-radius:0.5em;
    }
    .color1{background-color: #6D8DB7;}
    .color2{background-color: #70b76d;}
    .color3{background-color: #a7b76d;}
    .col{
        padding: 5px 12px;
    }
    .sin_asignar{
        background-color: #FFF9C4;
    }
    .reproceso{
        background-color: #ffeac4;
    }
    .produccion{
        background-color: #E8F5E9;
    }

    .v-data-table--fixed-header thead tr:nth-child(4) th {
        top: 96px;
    }
    .v-data-table--fixed-header thead tr:nth-child(3) th {
        top: 64px;
    }
    .v-data-table--fixed-header thead tr:nth-child(2) th {
        top: 32px;
    }
    .restriccion{
        background-color: #f4b1b1 !important;
    }
    .harina{
        background-color:#84B0DA;color:#fff !important; padding:0.2em 0.8em; border-radius:1em;
    }
    .aceite{
        background-color:#6D8DB7;color:#fff !important; padding:0.2em 0.8em; border-radius:1em;
    }
    .linea{
        background-color:#6D8DB7;color:#fff !important; padding:0.3em 0.5em; border-radius:0.5em;
    }
</style>